var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakersAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,7.1c0.5,0.5,1,1.1,1.3,1.8c0.3,0.7,0.5,1.4,0.6,2.1c0.1,0.7,0,1.5-0.2,2.2c-0.1,0.5-0.3,1-0.6,1.5 c-0.3,0.5-0.6,0.9-1,1.3l-0.5-0.5c0.7-0.7,1.2-1.5,1.4-2.5c0.3-1,0.3-1.9,0-2.9c-0.1-0.5-0.3-0.9-0.6-1.4c-0.2-0.4-0.5-0.8-0.9-1.2 L16.1,7.1z M14.3,9c0.5,0.5,0.8,1,1,1.7c0.2,0.6,0.2,1.3,0,1.9c-0.2,0.6-0.5,1.2-1,1.7l-0.5-0.5c0.4-0.4,0.6-0.8,0.8-1.3 c0.1-0.5,0.1-1,0-1.5c-0.1-0.5-0.4-1-0.8-1.4L14.3,9z M6,9.8c0-0.2,0.1-0.4,0.2-0.5C6.4,9.1,6.5,9,6.8,9h1.2l4.2-2.9 C12.2,6,12.3,6,12.4,6c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v10.5c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0-0.3-0.1l-4.2-2.9H6.8c-0.2,0-0.4-0.1-0.5-0.2C6.1,13.9,6,13.7,6,13.5V9.8z M12,7.1L8.2,9.8l-1.4,0v3.7h1.4l3.8,2.7 V7.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakersAudio);
export default __webpack_public_path__ + "static/media/speakers-audio.a32b2c401221fe390a7387c45b4ea0e3.svg";
export { ForwardRef as ReactComponent };